import type { SurveyConfig } from "@expert/app-config/types";
import type { PartnerProgram } from "@/shared-types";

export const selectProgramName = (
    useCustomerAgreementProgramName: boolean,
    wasClaimFiled: boolean,
    partnerConfigProgramName: string | undefined,
    customerAgreementProgramName: string | undefined,
    ignoreProgram: boolean,
    excludedPrograms: string[],
): string | undefined => {
    const programName = useCustomerAgreementProgramName ? customerAgreementProgramName : partnerConfigProgramName;
    const isExcludedProgram = excludedPrograms.some(
        (excludedProgram) => excludedProgram.toLowerCase() === programName?.toLowerCase(),
    );

    if (!programName || isExcludedProgram) {
        return ignoreProgram ? "NA" : undefined;
    }
    return wasClaimFiled ? `${programName}-retail` : programName;
};

export const selectSurveyId = (
    useCustomerAgreementProgramName: boolean,
    wasClaimFiled: boolean,
    customerProgram: PartnerProgram | undefined,
    surveyConfig: SurveyConfig | undefined,
): string | undefined => {
    const config = useCustomerAgreementProgramName ? surveyConfig : customerProgram?.survey;
    return wasClaimFiled ? config?.claimsSurveyId : config?.generalSurveyId;
};
